import { WorldMapPointKind } from "@/types/location"
import { WorldMapPoint } from "@/utils/worldMapPoints"

export type GuardiansMapLayerKey = WorldMapPointKind | "players"

export interface GuardiansMapFilters {
  scan: boolean
  boss: boolean
  worldboss: boolean
  cardshop: boolean
  boostershop: boolean
  postoffice: boolean
  treasure: boolean
  bank: boolean
  cityhall: boolean
  hotel: boolean
  wisetree: boolean
  hangar: boolean
  players: boolean
  onlyAvailable: boolean
}

export const DEFAULT_GUARDIANS_MAP_FILTERS: GuardiansMapFilters = {
  scan: true,
  boss: true,
  worldboss: true,
  cardshop: true,
  boostershop: true,
  postoffice: true,
  treasure: true,
  bank: true,
  cityhall: true,
  hotel: true,
  wisetree: true,
  hangar: true,
  players: true,
  onlyAvailable: false,
}

export function countActiveMapFilters(
  filters: GuardiansMapFilters,
  options?: { includePlayers?: boolean }
): number {
  let count = 0
  if (!filters.scan) count += 1
  if (!filters.boss) count += 1
  if (!filters.worldboss) count += 1
  if (!filters.cardshop) count += 1
  if (!filters.boostershop) count += 1
  if (!filters.postoffice) count += 1
  if (!filters.treasure) count += 1
  if (!filters.bank) count += 1
  if (!filters.cityhall) count += 1
  if (!filters.hotel) count += 1
  if (!filters.wisetree) count += 1
  if (!filters.hangar) count += 1
  if (options?.includePlayers !== false && !filters.players) count += 1
  if (filters.onlyAvailable) count += 1
  return count
}

export function filterWorldMapPoints(
  points: WorldMapPoint[],
  filters: GuardiansMapFilters
): WorldMapPoint[] {
  return points.filter((point) => {
    if (!filters[point.kind]) return false
    if (filters.onlyAvailable && !point.isAvailable) return false
    return true
  })
}

export function mapLayerLabel(key: GuardiansMapLayerKey): string {
  if (key === "scan") return "Сканы"
  if (key === "boss") return "Боссы"
  if (key === "worldboss") return "Мировой босс"
  if (key === "cardshop") return "Лавки"
  if (key === "boostershop") return "Бустеры"
  if (key === "postoffice") return "Почта"
  if (key === "treasure") return "Клады"
  if (key === "bank") return "Банк"
  if (key === "cityhall") return "Ратуша"
  if (key === "hotel") return "Гостиница"
  if (key === "wisetree") return "Мудрое дерево"
  if (key === "hangar") return "Ангар"
  return "Игроки"
}

export const MAP_FILTER_LAYER_KEYS: GuardiansMapLayerKey[] = [
  "scan",
  "boss",
  "worldboss",
  "cardshop",
  "boostershop",
  "postoffice",
  "treasure",
  "bank",
  "cityhall",
  "hotel",
  "wisetree",
  "hangar",
  "players",
]
